import { WorldCountry } from '../types';

export const argentinaData: WorldCountry = {
  code: 'AR',
  name: 'Argentina',
  slug: 'argentina',
  population: 45195774,
  topCities: [
    { name: 'Buenos Aires', slug: 'buenos-aires', population: 2890000 },
    { name: 'Córdoba', slug: 'cordoba-ar', population: 1329000 },
    { name: 'Rosario', slug: 'rosario', population: 948000 },
    { name: 'Mendoza', slug: 'mendoza', population: 115000 },
    { name: 'Tucumán', slug: 'tucuman', population: 549000 },
    { name: 'La Plata', slug: 'la-plata', population: 649000 },
    { name: 'Mar del Plata', slug: 'mar-del-plata', population: 593000 },
    { name: 'Salta', slug: 'salta', population: 535000 },
    { name: 'Santa Fe', slug: 'santa-fe-ar', population: 391000 },
    { name: 'San Juan', slug: 'san-juan-ar', population: 447000 },
    { name: 'Resistencia', slug: 'resistencia', population: 291720 },
    { name: 'Santiago del Estero', slug: 'santiago-del-estero', population: 252192 },
    { name: 'Corrientes', slug: 'corrientes', population: 346334 },
    { name: 'Posadas', slug: 'posadas', population: 319934 },
    { name: 'Neuquén', slug: 'neuquen', population: 340873 },
    { name: 'Bahía Blanca', slug: 'bahia-blanca', population: 301572 },
    { name: 'Paraná', slug: 'parana', population: 247863 },
    { name: 'Formosa', slug: 'formosa', population: 234354 },
    { name: 'San Luis', slug: 'san-luis', population: 183982 },
    { name: 'La Rioja', slug: 'la-rioja', population: 180995 },
    { name: 'Catamarca', slug: 'catamarca', population: 205912 },
    { name: 'Río Cuarto', slug: 'rio-cuarto', population: 157010 },
    { name: 'Comodoro Rivadavia', slug: 'comodoro-rivadavia', population: 182631 },
    { name: 'Concordia', slug: 'concordia', population: 170033 },
    { name: 'San Rafael', slug: 'san-rafael', population: 188018 },
    { name: 'Tandil', slug: 'tandil', population: 123871 },
    { name: 'Venado Tuerto', slug: 'venado-tuerto', population: 76432 },
    { name: 'Zárate', slug: 'zarate', population: 114269 },
    { name: 'Olavarría', slug: 'olavarria', population: 111320 },
    { name: 'Pergamino', slug: 'pergamino', population: 104590 },
    { name: 'Quilmes', slug: 'quilmes', population: 582943 },
    { name: 'Lanús', slug: 'lanus', population: 459263 },
    { name: 'San Miguel de Tucumán', slug: 'san-miguel-de-tucuman', population: 868000 },
    { name: 'Merlo', slug: 'merlo', population: 528494 },
    { name: 'General San Martín', slug: 'general-san-martin', population: 422542 },
    { name: 'Almirante Brown', slug: 'almirante-brown', population: 552902 },
    { name: 'Morón', slug: 'moron', population: 321109 },
    { name: 'Tigre', slug: 'tigre', population: 376381 },
    { name: 'Malvinas Argentinas', slug: 'malvinas-argentinas', population: 322375 },
    { name: 'Vicente López', slug: 'vicente-lopez', population: 269420 },
    { name: 'Tres de Febrero', slug: 'tres-de-febrero', population: 340071 },
    { name: 'San Isidro', slug: 'san-isidro', population: 292878 },
    { name: 'Esteban Echeverría', slug: 'esteban-echeverria', population: 300959 },
    { name: 'Moreno', slug: 'moreno', population: 452505 },
    { name: 'Florencio Varela', slug: 'florencio-varela', population: 426005 },
    { name: 'San Fernando', slug: 'san-fernando', population: 163240 },
    { name: 'Hurlingham', slug: 'hurlingham', population: 181241 },
    { name: 'Ituzaingó', slug: 'ituzaingo', population: 158197 },
    { name: 'José C. Paz', slug: 'jose-c-paz', population: 265981 },
    { name: 'Berazategui', slug: 'berazategui', population: 324244 },
    { name: 'Avellaneda', slug: 'avellaneda', population: 342677 },
    { name: 'Lomas de Zamora', slug: 'lomas-de-zamora', population: 616279 },
    { name: 'Banfield', slug: 'banfield', population: 75000 },
    { name: 'Quilmes Oeste', slug: 'quilmes-oeste', population: 85000 },
    { name: 'Bernal', slug: 'bernal', population: 50000 },
    { name: 'Villa Gesell', slug: 'villa-gesell', population: 31730 },
    { name: 'Pinamar', slug: 'pinamar', population: 25728 },
    { name: 'Necochea', slug: 'necochea', population: 92933 },
    { name: 'Miramar', slug: 'miramar', population: 19738 },
    { name: 'Balcarce', slug: 'balcarce', population: 43823 },
    { name: 'Azul', slug: 'azul', population: 65280 },
    { name: 'Tres Arroyos', slug: 'tres-arroyos', population: 57244 },
    { name: 'Carmen de Patagones', slug: 'carmen-de-patagones', population: 21178 },
    { name: 'San Carlos de Bolivar', slug: 'san-carlos-de-bolivar', population: 34190 },
    { name: 'Trenque Lauquen', slug: 'trenque-lauquen', population: 43021 },
    { name: 'General Pico', slug: 'general-pico', population: 58539 },
    { name: 'Santa Rosa', slug: 'santa-rosa', population: 124101 },
    { name: 'General Roca', slug: 'general-roca', population: 90607 },
    { name: 'Cipolletti', slug: 'cipolletti', population: 77000 },
    { name: 'San Carlos de Bariloche', slug: 'san-carlos-de-bariloche', population: 132876 },
    { name: 'Villa Carlos Paz', slug: 'villa-carlos-paz', population: 56637 },
    { name: 'San Francisco', slug: 'san-francisco', population: 61750 },
    { name: 'Villa María', slug: 'villa-maria', population: 80000 },
    { name: 'Río Tercero', slug: 'rio-tercero', population: 46400 },
    { name: 'Alta Gracia', slug: 'alta-gracia', population: 46583 },
    { name: 'Jesús María', slug: 'jesus-maria', population: 30151 },
    { name: 'Villa Dolores', slug: 'villa-dolores', population: 32306 },
    { name: 'San Salvador de Jujuy', slug: 'san-salvador-de-jujuy', population: 305891 },
    { name: 'Palpalá', slug: 'palpala', population: 52000 },
    { name: 'Libertador General San Martín', slug: 'libertador-general-san-martin', population: 68000 },
    { name: 'Perico', slug: 'perico', population: 25000 },
    { name: 'San Pedro', slug: 'san-pedro', population: 19200 },
    { name: 'Tilcara', slug: 'tilcara', population: 5800 },
    { name: 'Humahuaca', slug: 'humahuaca', population: 11369 },
    { name: 'La Quiaca', slug: 'la-quiaca', population: 14751 },
    { name: 'Cafayate', slug: 'cafayate', population: 11785 },
    { name: 'Metán', slug: 'metan', population: 40000 },
    { name: 'Orán', slug: 'oran', population: 83000 },
    { name: 'Tartagal', slug: 'tartagal', population: 80000 },
    { name: 'General Güemes', slug: 'general-guemes', population: 45000 },
    { name: 'Joaquín V. González', slug: 'joaquin-v-gonzalez', population: 25000 },
    { name: 'Embarcación', slug: 'embarcacion', population: 23000 },
    { name: 'Pichanal', slug: 'pichanal', population: 18000 },
    { name: 'Aguas Blancas', slug: 'aguas-blancas', population: 12000 },
    { name: 'Salvador Mazza', slug: 'salvador-mazza', population: 15000 },
    { name: 'Rosario de Lerma', slug: 'rosario-de-lerma', population: 18000 },
    { name: 'Campo Quijano', slug: 'campo-quijano', population: 8500 },
    { name: 'La Caldera', slug: 'la-caldera', population: 7500 },
    { name: 'Vaqueros', slug: 'vaqueros', population: 6000 },
    { name: 'Chicoana', slug: 'chicoana', population: 4000 },
    { name: 'Cerrillos', slug: 'cerrillos', population: 3500 },
    { name: 'El Carril', slug: 'el-carril', population: 9000 },
    { name: 'Coronel Moldes', slug: 'coronel-moldes', population: 5000 },
    { name: 'La Merced', slug: 'la-merced', population: 3000 }
  ]
};
